import { Button, Flex } from 'antd';
import { spacing, coreBrandColors, textStandard, fontSize, textColor } from '../../theming';
import logo from '../../assets/envelope_opened.svg';

function AltTab({ handler, handleBack, classes, email, t }) {
    return (
        <>
            <Flex
                vertical
                align="center"
                gap={spacing[5]}
                style={{
                    maxWidth: 'clamp(300px, 85vw, 400px)',
                }}
            >
                <img src={logo} alt="EnvelopOpened" className={classes['envelop-opened-logo']} />
                <h3 style={{ marginBottom: '16px' }}>{t('check')}</h3>
            </Flex>
            <div className={classes.content}>
                <p className={classes['check-instruciton']}>
                    {t('check-sub')} <b>{email}</b>
                </p>
                <Flex vertical justify="center" align="center" gap={spacing[6]}>
                    <Button className={classes['send-email-again']} size="large" onClick={() => handler(email)}>
                        {t('buttons.resend')}
                    </Button>
                    <Button
                        className={classes['return-button']}
                        htmlType="button"
                        type="link"
                        size="middle"
                        onClick={handleBack}
                        icon={
                            <i
                                className="fi-rr-arrow-left"
                                style={{ position: 'relative', top: 2, right: 5, fontSize: fontSize.lg }}
                            />
                        }
                    >
                        {t('buttons.back')}
                    </Button>
                </Flex>
            </div>
        </>
    );
}

export default AltTab;
